module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/thi-1fa619fa1f24dee0f5f35a6f290e07cf.jpg";